// Primary colors
var PINE_100 = '#1E4C49';
var ALOE_100 = '#3E6D6A';
var CACTUS_100 = '#84CDAA';
var CACTUS_80 = '#9DD7BB';
var MINT_100 = '#B9DDCC';
var MINT_80 = '#C7E4D6';
var SAGE_100 = '#DDECE5';
var MOSS_100 = '#EDF5F1';
var MOSS_70 = '#F2F8F5';
var MOSS_50 = '#F6FAF8';

// Secondary colors
var ATLANTIC_100 = '#053C53';
var ATLANTIC_90 = '#1E4F64';
var WALDEN_100 = '#00769B';
var MYSTIC_100 = '#B6E3ED';
var MYSTIC_80 = '#C4E9F1';
var MYSTIC_60 = '#D3EEF4';
var MYSTIC_40 = '#E2F4F8';
var MYSTIC_20 = '#F0F9FB';

// Accent colors
var MANGO_100 = '#FFE485';
var MANGO_60 = '#FFEFB6';
var MANGO_40 = '#FFF4CE';
var APRICOT_100 = '#FFB21C';
var APRICOT_60 = '#FFD177';
var APRICOT_40 = '#FFE0A4';
var APRICOT_10 = '#FFF7E8';

// Neutral colors
var CHARCOAL_100 = '#1D1D1F';
var CHARCOAL_90 = '#343435';
var SLATE_100 = '#657383';
var FOG_100 = '#DBDFE2';
var FOG_60 = '#E9ECEE';
var FOG_40 = '#F1F2F3';
var FOG_20 = '#F8F9F9';
var FOG_10 = '#FBFCFC';
var WHITE_100 = '#FFFFFF';

// Opacities
var CHARCOAL_40 = '#1D1D1F66';
var CHARCOAL_20 = '#1D1D1F33';
var CHARCOAL_10 = '#1D1D1F19';
var CHARCOAL_5 = '#1D1D1F0C';
var SLATE_50 = '#6573837F';
var WHITE_60 = '#FFFFFF99';
var WHITE_50 = '#FFFFFF7F';
var WHITE_20 = '#FFFFFF33';
var WHITE_10 = '#FFFFFF19';

// Semantic colors
var BERRY_100 = '#BB2F37';
var BERRY_20 = '#F1D5D7';
var BERRY_10 = '#F8EAEB';

// Gradients
var GRADIENT_ALOE_PINE = 'linear-gradient(180.0deg, rgba(62, 109, 106, 1.0) 0%, rgba(30, 76, 73, 1.0) 100%)';
var GRADIENT_MINT_CACTUS = 'linear-gradient(180.0deg, rgba(185, 221, 204, 1.0) 0%, rgba(132, 205, 170, 1.0) 80%)';
var GRADIENT_WHITE_MOSS = 'linear-gradient(180.0deg, rgba(255, 255, 255, 1.0) 0%, rgba(237, 245, 241, 1.0) 80%)';

export { ALOE_100 as A, BERRY_100 as B, CHARCOAL_100 as C, APRICOT_100 as D, MYSTIC_20 as E, FOG_40 as F, GRADIENT_ALOE_PINE as G, WALDEN_100 as H, CHARCOAL_5 as I, MYSTIC_80 as J, CHARCOAL_90 as K, MOSS_70 as L, MOSS_50 as M, MYSTIC_100 as N, FOG_100 as O, PINE_100 as P, FOG_10 as Q, CHARCOAL_40 as R, SAGE_100 as S, CHARCOAL_20 as T, CHARCOAL_10 as U, GRADIENT_WHITE_MOSS as V, WHITE_100 as W, MINT_100 as a, WHITE_10 as b, CACTUS_100 as c, MANGO_100 as d, APRICOT_60 as e, MANGO_60 as f, APRICOT_40 as g, SLATE_100 as h, FOG_60 as i, MOSS_100 as j, MINT_80 as k, CACTUS_80 as l, GRADIENT_MINT_CACTUS as m, WHITE_20 as n, WHITE_50 as o, WHITE_60 as p, ATLANTIC_100 as q, ATLANTIC_90 as r, FOG_20 as s, APRICOT_10 as t, MYSTIC_60 as u, MYSTIC_40 as v, MANGO_40 as w, SLATE_50 as x, BERRY_20 as y, BERRY_10 as z };
//# sourceMappingURL=color-palette-0a32e1d4.js.map
